import Vue from 'vue';
import Router from 'vue-router';
import {
	requireAuth,
	noAuthOnly
} from './utils/auth';
import store from './store/index';
import {
	fail
} from './utils/toast';
import swal from 'sweetalert2';

const HomePage = () => import( /* webpackChunkName: "homepage" */ './views/HomePage');
const Login = () => import( /* webpackChunkName: "login" */ './views/Login');
const LearnerRegistration = () => import( /* webpackChunkName: "learner-registration" */ './views/LearnerRegistration');
const Base = () => import( /* webpackChunkName: "base" */ './views/Base');
// const Counselling = () => import( /* webpackChunkName: "counselling" */ './views/Counselling');
const Forum = () => import( /* webpackChunkName: "forum" */ './views/forum/Index');
const CreatePostForm = () => import( /* webpackChunkName: "create-post-form" */ './views/forum/CreatePostForm');
const Logout = () => import( /* webpackChunkName: 'logout' */ './views/Logout');
const ForumThread = () => import( /* webpackChunkName: 'forum-thread' */ './views/forum/ForumThread');
const UserProfile = () => import( /* webpackChunkName: "userprofile" */ './views/user/UserProfile');
const Alumni = () => import( /* webpackChunkName: "alumni" */ './views/alumni/Index');
const Test = () => import( /* webpackChunkName: "test" */ './views/tests/Index');
const CourseLesson = () => import( /* webpackChunkName: "course-lesson" */ './views/courses/CourseLesson');
const AlumniProfile = () => import( /* webpackChunkName: "alumniprofile" */ './views/alumni/AlumniProfile');
const TestScore = () => import( /* webpackChunkName: "test-score" */ './views/tests/TestScore');
const CourseDetail = () => import( /* webpackChunkName: "course-detail" */ './views/courses/CourseDetail');
const CreateCourseDiscussion = () => import( /* webpackChunkName: "createcoursediscussion" */ './views/courses/CreateCourseDiscussion');
const Course = () => import( /* webpackChunkName: "course" */ './views/courses/Index');
const DiscussionPage = () => import( /* webpackChunkName: "discussionpage" */ './views/courses/DiscussionPage.vue');
const CourseDiscussion = () => import( /* webpackChunkName: "coursediscussion" */ './views/courses/CourseDiscussion');
const DiscussionIndex = () => import( /* webpackChunkName: "discussionindex" */ './views/courses/DiscussionIndex');
const Jobs = () => import( /* webpackChunkName: "jobs" */ './views/job/Jobs');
const JobDetail = () => import( /* webpackChunkName: "job-detail" */ './views/job/JobDetail');
const NotFound = () => import( /* webpackChunName: 'not-found' */ './views/NotFound');
const UserDashboard = () => import( /* webpackChunkName: 'user-dashboard' */ './views/user/UserDashboard');
const Skillset = () => import( /* webpackChunName: 'skillset' */ './views/Skillsets');
const Career = () => import( /* webpackChunName: 'career' */ './views/Careers');
const ForgotPassword = () => import( /* webpackChunkName: 'forgot-password' */ './views/ForgotPassword');
const ChangePassword = () => import( /* webpackChunkName: 'change-password' */ './views/password/ChangePassword');
const FormWrapper = () => import( /* webpackChunkName: 'form-wrapper' */ './views/password/Index');
const EmployerRegistration = () => import( /* webpackChunkName: 'employee-registration' */ './views/EmployerRegistration');

Vue.use(Router);

const router = new Router({
	mode: 'history',
	scrollBehavior(to, from, savedPosition) {
		let position = {
			x: 0,
			y: 0
		};
		if (savedPosition) {
			position = savedPosition;
		} else if (to.hash) {
			position.selector = to.hash;
		}
		return new Promise((resolve) => {
			setTimeout(() => {
				resolve(position);
			}, 500);
		});a
	},
	routes: [{
			path: '/',
			component: Base,
			children: [{
					path: '',
					name: 'homepage',
					component: HomePage,
					meta: {
						title: 'Homepage | Integrated Platform'
					}
				},

				{
					path: 'skillsets',
					name: 'skillsets',
					component: Skillset,
					meta: {
						title: 'Skillsets | Integrated Platform'
					},
					beforeEnter: requireAuth
				},
				{
					path: 'careers',
					name: 'careers',
					component: Career,
					meta: {
						title: 'Career | Integrated Platform'
					},
					beforeEnter: requireAuth
				},
				// {
				// 	path: 'counselling',
				// 	name: 'counselling',
				// 	component: Counselling,
				// 	meta: {
				// 		title: 'Counselling | Integrated Platform'
				// 	},
				// 	beforeEnter: requireAuth
				// },
				{
					path: 'forum',
					name: 'forum',
					component: Forum,
					meta: {
						title: 'Forum | Integrated Platform'
					},
					beforeEnter: requireAuth
				},
				{
					path: 'forum/:id/thread',
					name: 'forum-thread',
					component: ForumThread,
					meta: {
						title: 'Forum Thread | Integrated Platform'
					},
					props: true,
					beforeRouteUpdate: (to, from, next) => {
						if (to === from) {
							window.location.reload();
							return next();
						}
						return true;
					}
				},
				{
					path: 'create-post',
					name: 'create-forum-post',
					component: CreatePostForm,
					meta: {
						title: 'Create Post | Integrated Platform'
					},
					beforeEnter: requireAuth
				},
				{
					path: 'alumni',
					name: 'alumni',
					component: Alumni,
					meta: {
						title: 'Alumni | Integrated Platform'
					},
					beforeEnter: requireAuth
				},
				{
					path: '/users/:id/profile',
					name: 'user-profile',
					component: UserProfile,
					meta: {
						title: 'User Profile | Integrated Platform'
					},
					beforeEnter: requireAuth
				},
				{
					path: '/tests',
					name: 'test',
					component: Test,
					meta: {
						title: 'Test | Integrated Platform'
					},
					beforeEnter: requireAuth
				},
				{
					path: '/tests/:id/score',
					name: 'test-score',
					component: TestScore,
					meta: {
						title: 'Test Score | Integrated Platform'
					},
					beforeEnter: requireAuth
				},
				{
					path: '/courses',
					name: 'courses',
					component: Course,
					meta: {
						title: 'Courses | Integrated Platform'
					},
					beforeEnter: requireAuth
				},
				{
					path: '/courses/:id',
					name: 'course-detail',
					component: CourseDetail,
					meta: {
						title: 'Course Detail | Integrated Platform'
					},
					beforeEnter: requireAuth
				},
				{
					path: '/courses/:id/discussion',
					component: DiscussionIndex,
					beforeEnter: requireAuth,
					props: true,
					children: [{
							path: '/',
							name: 'course-discussion',
							component: CourseDiscussion
						},
						{
							path: ':discussionId',
							name: 'discussion-page',
							component: DiscussionPage
						}
					]
				},
				{
					path: '/courses/:id/discussion/new',
					name: 'create-course-discussion',
					component: CreateCourseDiscussion,
					beforeEnter: requireAuth
				},
        {
          path: '/courses/:onlineClassId/discussion/new',
          name: 'create-course-lesson-discussion',
          component: CreateCourseDiscussion,
          beforeEnter: requireAuth
        },
				{
					path: '/courses/:onlineClassId/lessons/:id',
					name: 'course-lessons',
					component: CourseLesson,
					beforeEnter: requireAuth,
					props: true
				},
				{
					path: '/alumni/:id/profile',
					name: 'alumni-profile',
					component: AlumniProfile,
					beforeEnter: requireAuth,
					props: true
				},
				{
					path: '/jobs',
					name: 'jobs',
					component: Jobs,
					meta: {
						title: 'Jobs | Integrated Platform'
					},
					beforeEnter: requireAuth
				},
				{
					path: '/jobs/:id',
					name: 'job-detail',
					component: JobDetail,
					meta: {
						title: 'Job Detail | Integrated Platform'
					},
					beforeEnter: requireAuth
				},
				{
					path: '/dashboard',
					name: 'dashboard',
					component: UserDashboard,
					meta: {
						title: 'Dashboard | Integrated Platform'
					},
					beforeEnter: requireAuth
				}
			]
		},
		{
			path: '/logout',
			name: 'logout',
			component: Logout,
			beforeEnter: requireAuth
		},
		{
			path: '/learner-registration',
			name: 'learner-registration',
			component: LearnerRegistration,
			meta: {
				title: 'Sign Up | Integrated Platform'
			},
			beforeEnter: noAuthOnly
		},
		{
			path: '/employer-registration',
			name: 'employer-registration',
			component: EmployerRegistration,
			meta: {
				title: 'Employer Registeration | Integrated Platform'
			},
			beforeEnter: noAuthOnly
		},
		{
			path: '/login',
			name: 'login',
			component: Login,
			meta: {
				title: 'Login | Integrated Platform'
			},
			beforeEnter: noAuthOnly
		},
		{
			path: '*',
			name: 'not-found',
			component: NotFound,
			meta: {
				title: '404 Not Found | Integrated Platform'
			}
		},
		{
			path: '/forgot-password',
			name: 'forgot-password',
			component: ForgotPassword,
			meta: {
				title: 'Forgot Password | Integrated Platform'
			},
			beforeEnter: noAuthOnly
		},
		{
			path: '/password',
			component: FormWrapper,
			children: [{
				path: '/*',
				name: 'change-password',
				component: ChangePassword,
				meta: {
					title: 'Change Password | Integrated Platform'
				}
			}]
		}
	]
});

router.beforeEach((to, from, next) => {
	//store.commit('resetSidebar');
	const user = store.getters.userObject;
	if (to.meta.entrepreneurAuth) {
		if (user.alumni && user.alumni.user_id && user.career.career.segment.category.name.toLowerCase() === 'entrepreneur') {
			next();
		} else {
			swal.fire({
				type: 'info',
				title: 'Oops',
				text: 'You need to be an entreprenuer to access this.'

			})
			next({
				name: 'dashboard'
			});
		}
	} else {
		next();
	}
});

export default router;
